/**
 * CondoDocumentList — the documents in a delivered package, item by item, with
 * download links (buyer and seller) and each not-applicable note.
 */

import React from 'react';
import styles from './CondoDocumentsPanel.module.css';
import { CONDO_DOCUMENTS_COPY as COPY } from './condoDocumentsCopy';
import { filesForItem, itemEntry, itemLabel } from './condoDocumentsModel';
import { CondoDocumentsAPI } from '../../agents/condoDocumentsAgent';

export default function CondoDocumentList({ pkg, checklist, transactionId }) {
  const rows = checklist.filter(
    (item) => filesForItem(pkg, item.code).length > 0 || itemEntry(pkg, item.code).not_applicable
  );

  return (
    <ul className={styles.docList} aria-label={COPY.deliveredDocumentsLabel}>
      {rows.map((item) => {
        const files = filesForItem(pkg, item.code);
        const entry = itemEntry(pkg, item.code);
        return (
          <li key={item.code} className={styles.docRow} data-testid={`condo-doc-${item.code}`}>
            <span className={styles.docLabel}>{itemLabel(item)}</span>
            {files.length > 0 ? (
              <span className={styles.docFiles}>
                {files.map((file) => (
                  <a
                    key={file.id}
                    className={styles.docLink}
                    href={CondoDocumentsAPI.downloadUrl(transactionId, file.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={COPY.download({ name: file.original_filename })}
                  >
                    {file.original_filename}
                  </a>
                ))}
              </span>
            ) : (
              <span className={styles.docNa}>
                {COPY.notApplicableSaved({ note: entry.note || '' })}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
